import { render, staticRenderFns } from "./DocsIATemplateComponent.vue?vue&type=template&id=a7fd16fc"
import script from "./DocsIATemplateComponent.vue?vue&type=script&lang=ts"
export * from "./DocsIATemplateComponent.vue?vue&type=script&lang=ts"
import style0 from "./DocsIATemplateComponent.vue?vue&type=style&index=0&id=a7fd16fc&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7fd16fc')) {
      api.createRecord('a7fd16fc', component.options)
    } else {
      api.reload('a7fd16fc', component.options)
    }
    module.hot.accept("./DocsIATemplateComponent.vue?vue&type=template&id=a7fd16fc", function () {
      api.rerender('a7fd16fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/DocsIATemplateComponent.vue"
export default component.exports